import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";
import Constants from "common/constant";
import { actions } from "features/course/slice";

export const DefaultStartPage = () => {
  const dispatch = useDispatch();
  const [start, setStart] = useState(true);
  const config = useSelector((state: RootState) => state.config);

  const handleAnimationEnd = () => {
    dispatch(actions.updateShowCourseTop(false));
    setStart(true);
  };

  return (
    <div
      className={`flex-col-el flex-center z-[100] w-full h-full bg-white absolute will-change-transform ${
        start ? "" : "animate__animated animate__bounceOutUp pointer-events-none"
      }`}
      onAnimationEnd={handleAnimationEnd}
    >
      <div className="flex-col-el flex-center relative w-full h-full">
        <img
          alt="コース スタート画面"
          src={`${Constants.assetHost}/assets/images/${config.userConfig.locale === "ja" || config.userConfig.locale === "ja_kanji" ? "display_bg_course" : `display_bg_course_${config.userConfig.locale}`}.png`}
          className="w-full h-full border-solid border-1 border-textcolor-black object-cover opacity-80 z-[-1]"
        />
      </div>
    </div>
  );
};
